"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.State = void 0;
const _ = __importStar(require("lodash"));
const slickgrid_1 = require("slickgrid");
function getItem(key) {
    const data = localStorage.getItem(key);
    if (data) {
        return JSON.parse(data);
    }
}
function setItem(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
}
function removeItem(key) {
    localStorage.removeItem(key);
}
class State {
    pluginName = 'State';
    static __name__ = 'State';
    eventHandler;
    options;
    grid;
    key;
    isDisabled = false;
    onStateChanged;
    constructor(options) {
        this.eventHandler = new slickgrid_1.SlickEventHandler();
        this.options = options;
        if (!window.localStorage) {
            console.warn('LocalStorage is not available.' +
                'Slickgrid statepersistor plugin will be disabled disabled.');
            this.isDisabled = true;
        }
        else {
            this.onStateChanged = new slickgrid_1.SlickEvent();
            this.key = options.key;
        }
    }
    init(grid) {
        if (this.isDisabled) {
            return;
        }
        this.grid = grid;
        this.eventHandler
            .subscribe(grid.onColumnsResized, this.onColumnsResized.bind(this))
            .subscribe(grid.onColumnsReordered, this.onColumnsReordered.bind(this))
            .subscribe(grid.onSort, this.onSort.bind(this));
    }
    destroy() {
        if (this.isDisabled) {
            return;
        }
        this.eventHandler.unsubscribeAll();
        this.save();
    }
    get isEmpty() {
        return !getItem(this.key);
    }
    save() {
        const state = {
            sortcols: _.map(this.grid.getSortColumns(), p => ({
                columnId: p.columnId,
                sortAsc: p.sortAsc
            })),
            viewport: this.grid.getViewport(),
            columns: _.map(this.grid.getColumns(), col => ({
                columnId: col.id,
                width: col.width
            })),
            knownColumns: _.map(this.options.defaultColumns, p => p.id)
        };
        setItem(this.key, state);
        this.onStateChanged.notify(state);
    }
    restore() {
        const state = getItem(this.key);
        if (!state) {
            return;
        }
        if (state.sortcols) {
            this.grid.setSortColumns(state.sortcols);
        }
        if (state.viewport) {
            this.grid.scrollRowIntoView(state.viewport.top, true);
        }
        if (state.columns && this.options.defaultColumns) {
            this.restoreColumns(state, this.options.defaultColumns);
        }
    }
    restoreColumns(state, defaults) {
        const knownColumns = state.knownColumns || [], statesIdentities = _.map(state.columns, p => p.columnId), defsById = _.reduce(defaults, (m, col) => ((m[col.id] = col), m), {});
        const cols = _.filter(defaults, p => {
            const hidden = statesIdentities.indexOf(p.id) > -1;
            if (p['frozen'] && hidden) {
                return true;
            }
        });
        const firstSystemIndex = cols.length;
        const visited = _.map(cols, p => p.id);
        _.each(state.columns, state => {
            if (visited.indexOf(state.columnId) > -1) {
                return;
            }
            visited.push(state.columnId);
            const column = defsById[state.columnId];
            if (!column) {
                return;
            }
            cols.push({ ...column, width: state.width });
        });
        _.each(defaults, (col, index, arr) => {
            if (knownColumns.indexOf(col.id) !== -1) {
                return;
            }
            if (index === 0) {
                cols.splice(firstSystemIndex + 1, 0, col);
                return;
            }
            const prev = arr[index - 1];
            const prevIndex = _.findIndex(cols, { id: prev.id });
            if (prevIndex > -1) {
                cols.splice(prevIndex + 1, 0, col);
                return;
            }
            cols.splice(firstSystemIndex + 1, 0, col);
        });
        for (let col of cols) {
            if (col.width == null) {
                col.width = 50;
            }
        }
        this.grid.setColumns(cols);
    }
    onColumnsResized(e, args) {
        try {
            this.save();
        }
        catch (err) {
            console.error(err);
        }
    }
    onColumnsReordered(e, args) {
        try {
            this.save();
        }
        catch (err) {
            console.error(err);
        }
    }
    onSort(e, args) {
        try {
            this.save();
        }
        catch (err) {
            console.error(err);
        }
    }
}
exports.State = State;
//# sourceMappingURL=State.js.map